import {$get, $post, $put, $delete, } from '@/others/ajax';
import config from '@/others/interface';
import moment from 'moment';
// 导入文件
function formatTen (num) {
  return num > 9 ? (num + '') : ('0' + num);
}
const plug = { //  定义一个对象
  install (Vue, options) { // 需要拥有一个 install 方法
    Vue.prototype.$get = $get;
    Vue.prototype.$post = $post;
    Vue.prototype.$put = $put;
    Vue.prototype.$delete = $delete;
    Vue.prototype.$config = config;
    Vue.prototype.$myConvertTime = (date) => {
      return moment(date).format('YYYY-MM-DD');
    };
    Vue.prototype.$myConvertTimeDetails = (date) => {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    };
  },
};
// 导出这个对象
export default plug;



// WEBPACK FOOTER //
// src/plug/$http/$http.js